import { GET_LOG_CHART } from '../types';
// contains chart data
const initialState = { chartData: {} };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_LOG_CHART:
            return {
                ...state,
                chartData: { ...payload },
                chartLoading: false
            };

        default:
            return state;
    }
}